/* eslint-disable */

export default el => {
    const video = el.querySelector('video');

    const show = () => {
        video.play();
        el.classList.add("show")
    }
    const hide = () => {
        video.pause();
        el.classList.remove("show")
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(e => {
            e.intersectionRatio > 0 ? show() : hide();
        });
    }, { threshold: [0] });

    observer.observe(el);

};

